export default __webpack_public_path__ + "static/media/webinaire_3.f0aeb4c2.jpg";